import IconRightContainer from './IconRightContainer'

export default IconRightContainer
